import { useTranslation } from 'react-i18next'

interface YamlPasteFieldProps {
  yamlText: string
  yamlError: string | null
  onYamlChange: (val: string) => void
}

export function YamlPasteField({
  yamlText,
  yamlError,
  onYamlChange,
}: YamlPasteFieldProps): React.ReactElement {
  const { t } = useTranslation('admin')
  return (
    <div>
      <label className="mb-1 block text-sm font-medium text-stone-700 dark:text-stone-300">
        {t('velociraptorSettings.install.apiClientYaml')}
      </label>
      <textarea
        value={yamlText}
        onChange={(ev) => {
          onYamlChange(ev.target.value)
        }}
        rows={8}
        aria-invalid={yamlError !== null}
        aria-describedby={yamlError === null ? undefined : 'yaml-error'}
        className="w-full rounded-lg border border-stone-300 bg-white px-3 py-2 font-mono text-xs text-stone-900 dark:border-stone-600 dark:bg-stone-700 dark:text-stone-100"
        placeholder={t('velociraptorSettings.placeholders.apiClientYaml')}
      />
      {yamlError !== null && (
        <p id="yaml-error" role="alert" className="mt-1 text-xs text-red-600 dark:text-red-400">
          {yamlError}
        </p>
      )}
    </div>
  )
}
